var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_381",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29250",
    "data-name": "Group 29250",
    transform: "translate(509 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -509, -10935)",
    filter: "url(#Ellipse_381)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_381-2",
    "data-name": "Ellipse 381",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-finn",
    transform: "translate(-491.994 -10921.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50139",
    "data-name": "Path 50139",
    d: "M33.987,34.917v-7.6A2.469,2.469,0,0,0,32.026,25c-1.079,0-2.616,1.816-2.616,3.092v6.825ZM5,34.917v-7.6A2.469,2.469,0,0,1,6.961,25c1.079,0,2.616,1.816,2.616,3.092v6.825Z",
    transform: "translate(0 -4.744)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50140",
    "data-name": "Path 50140",
    d: "M11.1,23.7v3.4H5.481c-.061-.229-.114-.458-.16-.7h.008A17.147,17.147,0,0,1,5,23.021C5,21.671,6.175,21,7.616,21S11.1,22.587,11.1,23.7Zm16.782,0v3.4h5.622c.061-.229.114-.458.16-.7h-.008a17.147,17.147,0,0,0,.328-3.379c0-1.35-1.175-2.021-2.616-2.021S27.885,22.587,27.885,23.7Z",
    transform: "translate(0 -3.795)",
    fill: "#aed581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50141",
    "data-name": "Path 50141",
    d: "M31.885,8.662V23.308H9V8.662C9,6.611,10.259,5,11.861,5a3.08,3.08,0,0,1,2.787,2.8,37.05,37.05,0,0,1,11.59.008A3.073,3.073,0,0,1,29.024,5C30.626,5,31.885,6.611,31.885,8.662Z",
    transform: "translate(-0.949)",
    fill: "#e7ebed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50142",
    "data-name": "Path 50142",
    d: "M28.648,16.721c0,3.211-4.019,5.721-9.154,5.721s-9.154-2.51-9.154-5.721S14.359,11,19.494,11,28.648,13.51,28.648,16.721ZM5,31.6H8.051v4.577H5Zm25.936,0h3.051v4.577H30.936Z",
    transform: "translate(0 -1.423)",
    fill: "#ffccbc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28947",
    "data-name": "Group 28947",
    transform: "translate(5.481 23.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50143",
    "data-name": "Path 50143",
    d: "M11.252,29v6.049a3.238,3.238,0,0,1-2.616-.679A10.277,10.277,0,0,1,5.63,29Zm16.782,0v6.049a3.238,3.238,0,0,0,2.616-.679A10.277,10.277,0,0,0,33.656,29Z",
    transform: "translate(-5.63 -29)",
    fill: "#7cb342"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28948",
    "data-name": "Group 28948",
    transform: "translate(13.391 12.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50144",
    "data-name": "Path 50144",
    d: "M27.442,15a.763.763,0,1,0,.763.763A.763.763,0,0,0,27.442,15Zm-10.68,0a.763.763,0,1,0,.763.763A.763.763,0,0,0,16.763,15ZM22.1,18.814a6.592,6.592,0,0,1-3.457-.88.763.763,0,1,1,.811-1.292,5.144,5.144,0,0,0,2.646.646,5.152,5.152,0,0,0,2.646-.646.763.763,0,1,1,.809,1.293A6.6,6.6,0,0,1,22.1,18.814Z",
    transform: "translate(-16 -15)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50145",
    "data-name": "Path 50145",
    d: "M31.885,26V39.731H9V26l1.175.461A30.024,30.024,0,0,0,20.442,28.07,30.024,30.024,0,0,0,30.71,26.461Z",
    transform: "translate(-0.949 -4.981)",
    fill: "#29b6f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinn);
export default __webpack_public_path__ + "static/media/finn.0ecbfc5b93484b9a00ae0b58521a2ac4.svg";
export { ForwardRef as ReactComponent };